<!-- Use class to set color
E.g. `<AppIndicatorDot class="text-primary-500" />` -->

<template>
  <span class="flex items-center gap-1 !bg-transparent">
    <div class="size-2 shrink-0 rounded-full bg-current"></div>
    <span
      v-if="label !== undefined"
      class="text-2xs font-semibold"
      >{{ label }}</span
    >
  </span>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: [String, Number],
    required: false,
    default: undefined,
  },
})
</script>
